<template>
    <div class="image-upload">
        <a-upload
            v-if="imageType === 1"
            accept="image/*"
            action="./api/main/attach/uploadImage"
            :headers="headers"
            :data="{ params: jsonParams }"
            :show-upload-list="false"
            :before-upload="beforeUpload"
            @change="handleChangeOfFile"
        >
            <div class="image-btn">
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                    {{ itemName }}
                </div>
            </div>
        </a-upload>

        <div v-if="imageType === 2 || imageType === 3" @mouseover="smallBtnVisible = true" @mouseout="smallBtnVisible = false">
            <div class="image-show small-btn" v-show="smallBtnVisible">
                <a-icon type="eye" @click="previewVisible = true" />
                <a-icon v-if="imageType !== 3" type="delete" @click="handleRemove" />
            </div>
            <img class="image-show" :src="imageUrl" alt="照片" />
        </div>

        <div v-if="imageType === 4">
            暂无照片
        </div>

        <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
            <img alt="example" style="width: 100%" :src="imageUrl" />
        </a-modal>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "UploadButton",
    props: {
        attachCfg: {
            type: Object,
            default: () => {}
        },
        state: {
            type: Number,
            default: 1
        },
        itemName: {
            type: String,
            default: "上传"
        }
    },
    data() {
        return {
            headers: {}, //上传请求头部
            loading: false,
            isReady: false,
            imageUrl: "",
            previewVisible: false,
            smallBtnVisible: false,
            jsonParams: null
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        imageType() {
            if (!this.imageUrl && this.state === 1) {
                return 1;
            } else if (this.imageUrl && this.state === 1) {
                return 2;
            } else if (this.imageUrl && this.state === 2) {
                return 3;
            } else {
                return 4;
            }
        },
        params: {
            get() {
                return {
                    fktable: this.attachCfg.fktable,
                    fkvalue: this.attachCfg.fkvalue,
                    isReady: this.isReady
                };
            }
        }
    },
    watch: {
        params: {
            handler(newValue) {
                if (newValue.fkvalue) {
                    this.getImage();
                }
            }
        }
    },
    created() {
        this.headers.Authorization = `Bearer ` + this.getToken;
        this.isReady = true;
    },
    activated() {
        this.isReady = true;
    },
    methods: {
        getImage() {
            this.imageUrl = "";
            this.loading = true;
            this.$FG_http
                .post(
                    "./api/main/attach/getOneImage",
                    {
                        params: this.params
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        if (data.data) {
                            this.imageUrl = data.data;
                        } else {
                            this.imageUrl = "";
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.$FG_message.error("P0002");
                    }
                });
        },
        beforeUpload() {
            this.loading = true;
            this.jsonParams = JSON.stringify(this.params);
            return true;
        },
        handleChangeOfFile(info) {
            if (info.file.status === "done") {
                //返回response
                this.loading = false;

                // Get this url from response in real world.
                this.getBase64(info.file.originFileObj, (imageUrl) => {
                    this.imageUrl = imageUrl;
                });
            }
        },
        handleRemove() {
            this.loading = true;
            this.$FG_http
                .post("./api/main/attach/deleteImage", {
                    params: this.params
                })
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        this.imageUrl = "";
                    }
                });
        },
        getBase64(img, callback) {
            const reader = new FileReader();
            reader.addEventListener("load", () => callback(reader.result));
            reader.readAsDataURL(img);
        }
    }
};
</script>
<style lang="scss" scoped>
.image-upload {
    float: left;
    border: 1px #c1c1c1 dashed;
    height: 227px;
    margin: 4px 20px;
    padding: 5px;
    width: 200px;
    text-align: center;
}
.image-show {
    height: 215px;
    width: 188px;
}
.image-btn {
    background: #fff;
    height: 215px;
    width: 188px;
    cursor: pointer;
    padding: 72px;
}
.small-btn {
    position: absolute;
    font-size: 18px;
    padding: 75px;
    color: #fff;
    background: #000;
    opacity: 0.5;
}
</style>
